import { getAudioParamRenderer } from './get-audio-param-renderer';
import { renderInputsOfAudioParam } from './render-inputs-of-audio-param';
export var renderAutomation = function renderAutomation(context, nativeOfflineAudioContext, audioParam, nativeAudioParam) {
  var audioParamRenderer = getAudioParamRenderer(context, audioParam);
  audioParamRenderer.replay(nativeAudioParam);
  return renderInputsOfAudioParam(context, audioParam, nativeOfflineAudioContext, nativeAudioParam);
};